var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChip20Dollars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 38.4 38.4",
    style: {
      enableBackground: "new 0 0 38.4 38.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2159D1;}\n\t.st1{fill:#083584;}\n\t.st2{fill:#2A6DFF;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.2,
    cy: 18.9,
    r: 19.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,9.3c1.7,0,3.3,0.3,4.8,0.9V0.3c-1.5-0.4-3.1-0.6-4.8-0.6s-3.3,0.2-4.8,0.6v9.9 C15.9,9.6,17.5,9.3,19.2,9.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.2,28.5c-1.7,0-3.3-0.3-4.8-0.9v9.9c1.5,0.4,3.1,0.6,4.8,0.6s3.3-0.2,4.8-0.6v-9.9 C22.5,28.2,20.9,28.5,19.2,28.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.8,18.9c0,1.7-0.3,3.3-0.9,4.8h9.9c0.4-1.5,0.6-3.1,0.6-4.8s-0.2-3.3-0.6-4.8h-9.9 C28.5,15.6,28.8,17.2,28.8,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.6,18.9c0-1.7,0.3-3.3,0.9-4.8H0.6C0.2,15.6,0,17.2,0,18.9s0.2,3.3,0.6,4.8h9.9C9.9,22.2,9.6,20.6,9.6,18.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.2,33.3c-7.9,0-14.4-6.5-14.4-14.4S11.3,4.5,19.2,4.5S33.6,11,33.6,18.9S27.1,33.3,19.2,33.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M10.9,24.4v-0.8c-1.7-0.1-2.8-0.9-3.2-1.9c-0.1-0.2-0.1-0.3-0.1-0.4c0-0.5,0.3-0.8,0.9-0.8 c0.4,0,0.7,0.2,0.9,0.6c0.2,0.5,0.6,0.9,1.5,1v-2.4l-0.5-0.1c-1.8-0.4-2.7-1.2-2.7-2.6c0-1.6,1.3-2.7,3.2-2.8v-0.8 c0-0.2,0.1-0.3,0.3-0.3c0.2,0,0.3,0.1,0.3,0.3v0.8c1.6,0.1,2.7,0.9,3,1.9c0,0.1,0.1,0.3,0.1,0.4c0,0.4-0.3,0.7-0.8,0.7 c-0.4,0-0.7-0.2-0.9-0.6c-0.3-0.5-0.7-0.9-1.3-1v2.4l0.5,0.1c1.8,0.4,2.8,1.2,2.8,2.6c0,1.7-1.4,2.7-3.3,2.8v0.8 c0,0.2-0.1,0.3-0.3,0.3C11.1,24.8,10.9,24.7,10.9,24.4z M10.9,17.9v-2.2c-0.9,0.1-1.3,0.5-1.3,1.1S10,17.7,10.9,17.9z M11.6,19.8 v2.3c1-0.1,1.4-0.5,1.4-1.1C13,20.4,12.7,20.1,11.6,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.5,22.9c0-0.4,0.1-0.6,0.6-1l2.9-2.8c1.2-1.1,1.5-1.6,1.5-2.3c0-0.8-0.6-1.4-1.5-1.4 c-0.8,0-1.3,0.4-1.7,1.2c-0.2,0.4-0.5,0.6-0.9,0.6c-0.5,0-0.9-0.3-0.9-0.8c0-0.2,0-0.3,0.1-0.4c0.3-1.1,1.5-2.1,3.4-2.1 c2,0,3.4,1.2,3.4,2.8c0,1.2-0.6,1.9-2.2,3.4l-2.1,2v0h3.6c0.5,0,0.8,0.3,0.8,0.8c0,0.5-0.3,0.8-0.8,0.8h-5.4 C15.9,23.7,15.5,23.4,15.5,22.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M22.8,18.9c0-3.1,1.5-5,3.9-5s3.9,1.9,3.9,5s-1.5,5.1-3.9,5.1S22.8,22,22.8,18.9z M28.7,18.9 c0-2.2-0.7-3.4-1.9-3.4c-1.2,0-1.9,1.2-1.9,3.4c0,2.2,0.7,3.4,1.9,3.4S28.7,21.1,28.7,18.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip20Dollars);
export default __webpack_public_path__ + "static/media/chip_20-dollars.21633182da752698136880bef081ead5.svg";
export { ForwardRef as ReactComponent };